import React, { Component } from 'react';
import { Element } from 'react-scroll';
import FontAwesome from 'react-fontawesome';

class Contatti extends Component {
  render() {
    return (
      <Element name="contatti-section">
        <div className="row">
          <div className="col-md-7 col-12 mx-auto py-4">
            <h1 className="text-uppercase">Contatti</h1>
            <div className="separator mx-auto"></div>
            <h5 className="mt-4">
              Per qualsiasi informazione o se hai deciso di lavorare con me contattami alla mail:
            </h5>
            <h6 className="my-2"><b>almantelli7@gmail.com</b></h6>
            <a className="my-3" href="mailto:almantelli7@gmail.com">
              <FontAwesome
                name='envelope-square'
                size='3x'
                className="black opacity"
              />
            </a>
          </div>
        </div>
      </Element>
    );
  }
}

export default Contatti;



// WEBPACK FOOTER //
// ./src/components/Contatti.js